
import {Component, Mixins, Prop, Watch} from "vue-property-decorator";
import PickerInputMixin from "@/mixins/PickerInputMixin.vue";
import MahkemeForm from "@/components/forms/MahkemeForm.vue";
import {MahkemeEntity} from "@/entity/MahkemeEntity";

@Component({
  components: {MahkemeForm},
})
export default class MahkemeSecim extends Mixins(PickerInputMixin) {
  @Prop() hideDetails!: string | boolean;
  @Prop({default: null}) item!: MahkemeEntity;
  @Prop({type: Object}) defaultValues!: any;
  @Prop() alacakBilgisi!: any;

  dialog = false;
  items!: Array<MahkemeEntity>;

  get isHideDetails() {
    return this.hideDetails || this.hideDetails === "";
  }

  mounted() {
    if (this.alacakBilgisi.mahkeme_id) {
      this.selectedItem=this.alacakBilgisi.mahkeme;
    }
    this.items = this.$store.state.mahkemeler
  }

  /*async load() {
    await this.$http.get('/api/v1/mahkeme/').then(response => {
      this.items = response.data;
    })
  }*/

  onSelectedItemChanged() {
    this.selectedId = this.value;
    this.$emit('mahkemeData', this.selectedItem);
    this.input();
  }

  async saveMahkeme(eklenenMahkeme: any) {
    this.dialog = false;

    const yeniMahkeme = eklenenMahkeme.mahkeme;
    this.items.push(yeniMahkeme);
    this.selectedItem = yeniMahkeme;

    this.$emit('mahkemeData', yeniMahkeme);
    this.input();
  }
}
